export function resolveDeployPrefix() {
    if (typeof document === 'undefined') {
        return '';
    }
    const l = document.location;
    if (l.pathname.startsWith('/reviews')) {
        return l.pathname.split('/').splice(0, 3).join('/');
    }
    return '';
}
//# sourceMappingURL=deployPrefixResolver.js.map